export default "__VITE_ASSET__B3MgPgTu__"